<template>
  <Grid gtc="3fr 1fr" gap="var(--r-space-sp)" align-items="start">
    <RModal
      ref="modal"
      title="Update product information"
      ok-btn-label="Update"
      @cancel="$event => $event()"
      @ok="onSave"
    >
      <q-editor
        ref="editor"
        v-model="productInformation"
        :content-style="{ listStylePosition: 'inside' }"
        :toolbar="Q_EDITOR_MIXIN_toolbarSettings"
        :fonts="Q_EDITOR_MIXIN_fonts"
        class="q-mt-lg"
        toolbar-rounded
        max-height="250px"
        toolbar-toggle-color="primary-1"
        @paste.native="Q_EDITOR_MIXIN_onPaste"
      />
    </RModal>

    <Grid gap="var(--r-space-md)">
      <RCard class="product-information relative-position">
        <Grid gaf="column" justify-content="space-between" align-items="center">
          <div class="text-subtitle-1 text-secondary-2">Product information</div>
          <EditIcon class="cursor-pointer" with-hover @click.native="openEditModal" />
        </Grid>

        <div
          v-if="product.content_summary"
          class="content-summary full-width q-mt-md"
          v-html="product.content_summary"
        />
        <div v-else class="text-body-1 text-secondary-1 q-mt-md">No product information is available</div>
      </RCard>
      <SubjectCategories />
    </Grid>

    <RCard class="metadata relative-position">
      <CustomMetaData :entity-id="product.id" entity-name="product" />
    </RCard>
  </Grid>
</template>

<script>
import { stripHtmlFromInput } from '@/lib/formatting.utils'
// Mixins
import Q_EDITOR_MIXIN from '@/mixins/q-editor-mixin'
// Libraries
import { mapState, mapActions } from 'vuex'
// Components
import RModal from '@/ui/RModal'
import CustomMetaData from '@/reusable/custom-meta-data/CustomMetaData'
import EditIcon from '@/ui/icons/EditIcon'
import SubjectCategories from './components/SubjectCategories'

export default {
  components: {
    RModal,
    CustomMetaData,
    EditIcon,
    SubjectCategories
  },

  mixins: [Q_EDITOR_MIXIN],

  props: {
    id: String // from route
  },

  data: () => ({
    productInformation: ''
  }),

  computed: {
    ...mapState('product-show', ['product'])
  },

  methods: {
    ...mapActions('product-show', ['updateProduct']),

    openEditModal() {
      this.productInformation = this.product.content_summary || ''
      this.$refs.modal.show()
    },

    onSave(hide, setLoading) {
      const productInformation = stripHtmlFromInput(this.productInformation)

      setLoading(true)
      this.updateProduct({ content_summary: productInformation })
        .then(hide)
        .finally(() => setLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.product-information {
  .content-summary {
    list-style-position: inside;
  }
}
</style>
